import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getLoginOnboardingWidgetStyles = () => {
  return StyleSheet.create({
    progressBarContainerdefaultStyle: {
      paddingHorizontal: tokens.spacing.SPACING_20,
      marginTop: tokens.spacing.SPACING_24,
      height: tokens.spacing.SPACING_40
    },
    progressBarContainer: {
      height: tokens.spacing.SPACING_4,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_2,
      marginLeft: tokens.spacing.SPACING_0,
      marginRight: tokens.spacing.SPACING_0,
      backgroundColor: '#D2D5F6'
    },
    progressBar: {
      position: 'absolute',
      height: tokens.spacing.SPACING_4,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_2,
      backgroundColor: '#027BFC'
    },
    mainContainerDefaultStyle: {
      alignSelf: 'center',
      justifyContent: 'center',
      overflow: 'hidden'
    },
    lottieDefaultStyle: {
      marginTop: tokens.spacing.SPACING_32
    },
    onboardingTitleDefaultStyle: {
      alignSelf: 'center',
      justifyContent: 'center',
      marginTop: tokens.spacing.SPACING_24
    },
    onboardingSubTitleDefaultStyle: {
      alignSelf: 'center',
      justifyContent: 'center',
      marginTop: tokens.spacing.SPACING_8
    }
  });
};